
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/store-detail",
      function () {
        return require("private-next-pages/templates/store-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/store-detail"])
      });
    }
  